import { render, staticRenderFns } from "./OrderBlock.vue?vue&type=template&id=1a8ffd2d&scoped=true&"
import script from "./OrderBlock.vue?vue&type=script&lang=js&"
export * from "./OrderBlock.vue?vue&type=script&lang=js&"
import style0 from "./OrderBlock.vue?vue&type=style&index=0&id=1a8ffd2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8ffd2d",
  null
  
)

export default component.exports